import { Expose } from "class-transformer";

export class CreateIssueDto {
  @Expose()
  location: string;

  @Expose()
  description: string;

  @Expose()
  files?: Array<{ key: string }>;
}
